import { render, staticRenderFns } from "./styleB.vue?vue&type=template&id=b7df2b4e&"
import script from "./styleB.vue?vue&type=script&lang=ts&"
export * from "./styleB.vue?vue&type=script&lang=ts&"
import style0 from "./styleB.vue?vue&type=style&index=0&module=true&lang=scss&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports